import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DisclosureEffects, disclosureReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([DisclosureEffects]), StoreModule.forFeature(`disclosure`, disclosureReducer)]
})
export class DisclosureStateModule {}
